<template>
  <!-- 模版页面 -->
  <div class="test-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-select
            v-model="query.cycle"
            placeholder="请选择任务类型"
            @change="getData(1)"
          >
            <el-option :value="undefined" label="全部"></el-option>
            <el-option value="daily" label="普通盲盒"></el-option>
            <el-option value="battle" label="热血盲盒"></el-option>
            <el-option value="upgrade" label="幸运升级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.user_id" placeholder="请输入uid"></el-input>
        </el-form-item>
        <el-form-item label="时间段：">
          <el-date-picker
            style="width: 200px"
            v-model="query.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          ——
          <el-date-picker
            style="width: 200px"
            v-model="query.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getData"
            >确定</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="cycle" label="任务类型" align="center">
        </el-table-column>
        <el-table-column prop="behavior" label="任务途径" align="center">
        </el-table-column>
        <el-table-column prop="title" label="任务名称" align="center">
        </el-table-column>
        <el-table-column prop="name" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="user_id" label="领取UID" align="center">
        </el-table-column>
        <el-table-column prop="amount" label="领取金额" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="领取时间" align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'
import saveFile from '@/utils/saveFile'


export default {
  data() {
    return {
      loading: false, //加载动画
      query: {
        page: 1,
        cycle: undefined,
        id: undefined,
        start_time: '',
        end_time: ''
      },
      dataList: undefined, //数据列表
      dataMeta: undefined, //底部跳转页面条
    }
  },
  created() {
    // this.getData()
  },
  methods: {
    getData(num) {
      if (num == 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('task_record', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    handleExport() {
      //保存任务
      //表单验证后发起请求
      let params = this.query

      http
        .post(
          api + 'task_record_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '任务记录.xlsx'
          })
        }).finally(() => {
        })
    },
  }

}

</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    // width: 800px;
  }
}
</style>
